// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// UiLanguage — source: shared/config/locale.config.json § languages § values

export const UI_LANGUAGE_VALUES = ["en", "es", "he", "zh"] as const;
export type UiLanguage = (typeof UI_LANGUAGE_VALUES)[number];

export const uiLanguageLocale: Record<UiLanguage, "en-US" | "es-ES" | "he-IL" | "zh-CN"> = {
  "en": "en-US",
  "es": "es-ES",
  "he": "he-IL",
  "zh": "zh-CN",
};

export const uiLanguageNativeName: Record<UiLanguage, "English" | "Espa\u00f1ol" | "\u05e2\u05d1\u05e8\u05d9\u05ea" | "\u4e2d\u6587"> = {
  "en": "English",
  "es": "Espa\u00f1ol",
  "he": "\u05e2\u05d1\u05e8\u05d9\u05ea",
  "zh": "\u4e2d\u6587",
};

export const uiLanguageDir: Record<UiLanguage, "ltr" | "rtl"> = {
  "en": "ltr",
  "es": "ltr",
  "he": "rtl",
  "zh": "ltr",
};

